module.exports = __webpack_public_path__ + "img/3.fa2573d2.jpg";